let _vm: any = null;

// setting the vm of the vue instance
export function setVm(vm: any) {
	_vm = vm;
}

// getting the vm of the vue instance
export function getVm() {
	_vm.constants = _vm.$children[0];
	return _vm;
}
